import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/more',
    name: 'more',
    component: () => import('../views/more.vue')
  },
  
  // {
  //   path: '/transform',
  //   name: 'transform',
  //   component: () => import('../views/transform.vue')
  // },

  // 测试
  // {
  //   path: '/demo',
  //   name: 'demo',
  //   component: () => import('../views/demo.vue')
  // },
  // {
  //   path: '/demo2',
  //   name: 'demo2',
  //   component: () => import('../views/demo02.vue')
  // },
  // {
  //   path: '/co',
  //   name: 'co',
  //   component: () => import('../views/co.vue')
  // },




]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
